import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Radio, RadioGroup, Stack, Box, Text } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import InactiveStudentsTable from "../../../containers/admin/students/inactiveStudentsTable";
import SearchBar from "../../../containers/admin/students/searchbar";
import StudentReport from "../../../containers/admin/students/models/student-report";

const InactiveStudents = () => {
  const model = useSelector((state) => state.model.isOpen18);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [inactivePeriod, setInactivePeriod] = useState("oneWeek");

  return (
    <Layout>
      <SearchBar
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
      />

      <Box mb={4} p={4} bg="white" borderRadius="md" boxShadow="sm">
        <RadioGroup onChange={setInactivePeriod} value={inactivePeriod}>
          <Stack direction="row" spacing={8} align="center">
            <Radio 
              value="oneWeek"
              size="md"
              colorScheme="blue"
            >
              <Text fontSize="sm" color="gray.700" fontWeight="medium">
                الطلاب الغير نشطين لمدة اسبوع
              </Text>
            </Radio>
            <Radio 
              value="twoWeeks"
              size="md"
              colorScheme="blue"
            >
              <Text fontSize="sm" color="gray.700" fontWeight="medium">
                الطلاب غير النشطين لمدة اسبوعين
              </Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </Box>

      <InactiveStudentsTable
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        inactivePeriod={inactivePeriod}
      />

      {model && (
        <StudentReport
          student_id={selectedData?.id}
          selectedData={selectedData}
        />
      )}
    </Layout>
  );
};

export default InactiveStudents;
